import { faArrowDown } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a down arrow icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/arrow-down?f=classic&s=solid
 */
export const ArrowDownIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faArrowDown} {...props} />;
};
